import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { Observable } from 'rxjs';
import { ConsultaList } from 'src/app/shared/model/core/ConsultaList.model';
import { Proyecto } from 'src/app/shared/model/gestion-proyectos/proyecto';
import { OportunidadesListaBase, VistaOportunidades } from '../oportunidades-comun/oportunidades-lista-base';

/** Oportunidades del líder de desarrollo; pinta la plantilla compartida de Marketing sin alta ni filtro de estado. */
@Component({
  selector: 'app-oportunidades-desarrolladores',
  standalone: true,
  templateUrl: '../oportunidades-marketing/oportunidades-marketing.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    NgxMatSelectSearchModule,
  ],
})
export class OportunidadesDesarrolladoresComponent extends OportunidadesListaBase {
  readonly vista: VistaOportunidades = {
    variante: 'desarrolladores',
    titulo: 'Administración de Oportunidades de Líder',
    descripcion: 'Consulte oportunidades asignadas, revise su semáforo y acceda directamente al seguimiento.',
    textoSinResultados: 'Ajuste los filtros para consultar otro conjunto de registros.',
    conAlta: false,
    conFiltroEstatus: false,
  };

  protected readonly rutaSeguimiento = 'PROCESO/seguimiento-desarrollo';

  protected consultaOportunidades(filtro: ConsultaList<Proyecto>): Observable<any> {
    return this.service.getProjectsWithPaginationDeveloper(filtro);
  }
}
